import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import Flex from "../Flex/Flex";
import FAIcon from "../Icon/FAIcon";

export const StatusBar = ({ type, onClick, onClose, children, style = {} }) => {
  const getColor = () => {
    switch (type) {
      case "success":
        return "success";
      case "info":
        return "warning";
      case "error":
        return "danger";
      default:
        return "lightBlue";
    }
  };

  return (
    <Flex
      style={{
        cursor: onClick ? "pointer" : "none",
        ...style,
      }}
      p={2}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      borderRadius="8px"
      bg={getColor()}
    >
      <Flex
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
        flex={0.9}
      >
        {children}
      </Flex>
      {onClose && (
        <Flex onClick={onClose} alignItems="center">
          <FAIcon
            fontSize={16}
            style={{
              cursor: onClose ? "pointer" : "none",
            }}
            onClick={onClose}
            icon={faTimes}
          />
        </Flex>
      )}
    </Flex>
  );
};
